import React from 'react';
import { Card as CardBase } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import styled from 'styled-components/native';

import ImageBackground from '@src/components/ImageBackground';
import { Business } from '@src/types';

type Props = {
  item: Business;
};

const Card = styled(CardBase)`
  overflow: hidden;
`;

const Cover = styled(ImageBackground).attrs({
  resizeMode: 'cover',
})`
  width: 100%;
  height: 200px;
`;

const BusinessCard: React.FC<Props> = ({ item: { cover, name, id } }) => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(
    () => navigation.navigate('Location', { id }),
    [id, navigation]
  );

  return (
    <Card onPress={handlePress}>
      <Cover source={cover?.source ?? { uri: '' }} />
      <Card.Title title={name} />
    </Card>
  );
};

export default React.memo(BusinessCard);
